module.exports = __webpack_public_path__ + "img/league_banner1.7cca5743.png";